import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { User } from '../../interfaces/user';
import { getAirshipChannelId } from '../../utils/airshipHandler';
import { getLanguageFromLocalStorage } from '../../i18n';
import LocalAuth from '@shamrock-core/common/authentication/local-authentication';
import airshipService from '../../services/airship.service';
import { RootState } from 'bootstrap';

interface Props {
  permissions?: string[];
  user?: User;
}

function Dashboard({ permissions, user }: Props) {
  const Config = require('Config');
  const navigate = useNavigate();
  const hasCorePermission =
    permissions?.includes('invoicemanager.User') ||
    permissions?.includes('fuel.User') ||
    permissions?.includes('shops.User') ||
    permissions?.includes('loadboard.User') ||
    permissions?.includes('tms.user.basic') ||
    permissions?.includes('tms.user.premium') ||
    permissions?.includes('tms.user.enterprise') ||
    permissions?.includes('carrierpro.PermissionsAdmin') ||
    permissions?.includes('carrierpro.CompanyAdmin') ||
    permissions?.includes('credit.User') ||
    permissions?.includes('factoring.Userr') ||
    permissions?.includes('carrierpro.RepCompanyAdmin') ||
    permissions?.includes('trial.User');
  const language = getLanguageFromLocalStorage();
  const features = useSelector((state: RootState) => state.app.features);
  const cpua5206 = features.includes('CPUA-5206');

  const handleStoreDeviceInformation = async () => {
    try {
      const airshipChannelId = await getAirshipChannelId();
      const email = LocalAuth.getUser().email as string;
      await airshipService.setDeviceLanguage(airshipChannelId, email, language);
      localStorage.setItem('HAS_SET_LANG_DEVICE_INFO', 'true');
    } catch (err) {
      console.log('Error while trying to process device information', err);
    }
  };

  useEffect(() => {
    const hasSetLangDeviceInfo = localStorage.getItem('HAS_SET_LANG_DEVICE_INFO') || false;
    if (!hasSetLangDeviceInfo && !cpua5206) {
      handleStoreDeviceInformation();
    }
  }, []);

  useEffect(() => {
    if (user && user.company_id === '9000004') {
      navigate('/factoring');
    } else if (user && user.company_id === '9000003') {
      navigate('/fuel');
    } else if (permissions?.includes('invoicemanager.User')) {
      navigate('/factoring');
    } else if (permissions?.includes('fuel.User')) {
      navigate('/fuel');
    } else if (permissions?.includes('ryantrans.Loadboard')) {
      navigate('/freight');
    } else if (!hasCorePermission && permissions?.includes('ryantrans.Shipper')) {
      window.location.href = Config.shipperPortalUrl;
    } else {
      navigate('/credit');
    }
  }, []);

  return <></>;
}

function mapStateToProps(state) {
  return { permissions: state.app.permissions, user: state.app.user };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
